export default "__VITE_ASSET__DA_oS5qK__"